// Prevent unprompted Zendesk chat connection:
// https://support.zendesk.com/hc/en-us/articles/360039299153-Optimizing-Chat-and-Web-Widget-performance
// https://support.zendesk.com/hc/en-us/articles/360038807274-ConnectOnPageLoad-Configuration-best-practices-for-common-use-cases
window.zESettings = {
	webWidget: {
		chat: {
			connectOnPageLoad: false
		}
	}
};



// WEBPACK FOOTER //
// ./client/src/core/components/zendesk/zendesk.js